<template>
  <div class="page trips-history">
    <h1>Ritten historiek</h1>
  </div>
</template>

<script>
export default {
name: "TripsHistory"
}
</script>
